import React, { useState } from 'react';

const Amenities = ({ amenities = [], cabinClass = "Basic Economy" }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // Define available amenities with their exact SVG icons and labels
  const availableAmenities = {
    wifi: {
      icon: (
        <svg viewBox="0 0 200 200" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" role="presentation" style={{ width: 'inherit', height: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
          <path d="M190 69.21l-11.274 12c-46.495-39.409-111.465-38.977-157.451 0L10 69.21c52.447-45.616 127.516-45.648 180 0zM35.108 95.932l11.275 12c32.137-24.87 75.08-24.882 107.235 0l11.275-12c-38.543-31.308-91.249-31.306-129.785 0zm24.827 26.425l11.487 12.226c17.795-10.694 39.361-10.694 57.157 0l11.486-12.225c-24.488-16.82-55.625-16.832-80.13-.001zm22.993 24.473L100 165l17.072-18.17c-11.178-4.36-22.947-4.367-34.144 0z"></path>
        </svg>
      ),
      label: 'Basic web browsing (fee)'
    },
    entertainment: {
      icon: (
        <svg viewBox="0 0 200 200" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" role="presentation" style={{ width: 'inherit', height: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
          <path d="M164 44H36c-8.836 0-16 7.164-16 16v80c0 8.836 7.164 16 16 16h128c8.836 0 16-7.164 16-16V60c0-8.836-7.164-16-16-16zm0 96H36V60h128v80zm-45.667-39.167L86.382 120.25v-40.5l31.951 21.083z"></path>
        </svg>
      ),
      label: 'Seatback on-demand video'
    },
    power: {
      icon: (
        <svg viewBox="0 0 200 200" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" role="presentation" style={{ width: 'inherit', height: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
          <path d="M115.644 51.288V25.855c-.009-7.792 11.753-7.706 11.762.013V51.33H147v11.73h-7.746v38.361c.026 22.854-19.044 28.592-23.428 29.973v12.138h-8.07v46.458H92.039v-46.484h-7.555v-11.933c-13.507-3.492-23.557-15.681-23.573-30.24V62.965H53V51.247h19.566V25.855c-.009-7.792 11.753-7.706 11.762.013v25.42h31.316z"></path>
        </svg>
      ),
      label: 'Power & USB outlets'
    },
    meal: {
      icon: (
        <svg viewBox="0 0 200 200" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" role="presentation" style={{ width: 'inherit', height: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
          <path d="M145.626 109.696h34.828v15c0 8.284-6.716 15-15 15H150v20H50v-20H34.547c-8.284 0-15-6.716-15-15v-15h97.071l38.725-38.725c5.858-5.858 15.355-5.858 21.213 0l3.897 3.897l-34.827 34.828zM59.639 80.405a19.807 19.807 0 0 1-3.708 16.521l7.886 6.148a29.801 29.801 0 0 0 5.581-24.855c-1.432-6.391-8.161-15.014-9.155-19.521a19.822 19.822 0 0 1 3.604-16.313l-7.946-6.07a29.818 29.818 0 0 0-5.423 24.538c1.383 6.273 8.223 15.366 9.161 19.552zm19.785-.001a19.81 19.81 0 0 1-3.708 16.521l7.886 6.148a29.806 29.806 0 0 0 5.581-24.856c-1.432-6.391-8.163-15.02-9.155-19.521a19.821 19.821 0 0 1 3.604-16.313l-7.946-6.07a29.82 29.82 0 0 0-5.424 24.538c1.384 6.275 8.224 15.367 9.162 19.553zm16.234-8.311c1.384 2.268 3.622 6.478 4.033 8.312a19.805 19.805 0 0 1-3.708 16.521l7.887 6.148a29.808 29.808 0 0 0 5.58-24.855c-1.432-6.391-8.163-15.022-9.155-19.521a19.817 19.817 0 0 1 3.604-16.312l-7.946-6.072a29.822 29.822 0 0 0-5.424 24.539c.891 4.038 4.411 10.043 5.129 11.24z"></path>
        </svg>
      ),
      label: 'Light meal (fee)'
    }
  };

  // Filter amenities based on what's available
  const filteredAmenities = amenities.filter(amenity => availableAmenities[amenity]);

  if (filteredAmenities.length === 0) {
    return null;
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className={`af2q ${isOpen ? 'af2q-mod-expanded' : ''}`}
      aria-label="Quality icons"
      onClick={handleToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        outline: 'none',
        backgroundColor: '#f0f3f5',
        borderRadius: '18px',
        padding: '12px 16px',
        transition: 'all 0.3s ease',
        position: 'relative',
        minWidth: 'fit-content',
        maxWidth: '200px'
      }}
    >
      {/* Arrow positioned in top-right corner - Always visible */}
      <div 
        className="af2q-chevron-rail" 
        style={{ 
          position: 'absolute',
          top: !isOpen ? '12px' : '16px',
          right: "12px",
          zIndex: 1
        }}
      >
        <div 
          className="af2q-chevron-wrapper"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.3s ease',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            color: '#666'
          }}
        >
          <svg 
            viewBox="0 0 200 200" 
            width="1em" 
            height="1em" 
            xmlns="http://www.w3.org/2000/svg" 
            className="af2q-chevron-icon" 
            role="presentation"
          >
            <path d="M100 132.5c-3.873 0 .136 2.376-64.801-51.738l9.603-11.523L100 115.237l55.199-45.999l9.603 11.523C99.806 134.924 103.855 132.5 100 132.5z" />
          </svg>
        </div>
      </div>

      <div className="af2q-container" style={{ display: 'flex', alignItems: 'center' }}>
        {/* Content Rail */}
        <div className="af2q-content-rail" style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
          {/* Quality Items */}
          <div 
            className="af2q-quality-items"
            style={{
              display: 'flex',
              flexDirection: isOpen ? 'column' : 'row',
              gap: isOpen ? '8px' : '4px',
              alignItems: isOpen ? 'flex-start' : 'center',
              width: '100%',
              paddingRight: "20px" // Add padding when expanded to avoid arrow overlap
            }}
          >
            {filteredAmenities.map((amenity) => (
              <div
                key={amenity}
                className="af2q-qitem"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: isOpen ? '4px 0' : '0'
                }}
              >
                <span className="af2q-qicon">
                  <div 
                    className="DlDu"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '16px',
                      height: '16px',
                      color: '#333'
                    }}
                  >
                    <span style={{
                      transform: 'translate3d(0px, 0px, 0px)',
                      verticalAlign: 'middle',
                      WebkitFontSmoothing: 'antialiased',
                      width: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {availableAmenities[amenity].icon}
                    </span>
                  </div>
                </span>
                {/* Show text only when expanded */}
                {isOpen && (
                  <span 
                    className="af2q-qmsg"
                    style={{
                      fontSize: '12px',
                      color: '#333',
                      whiteSpace: 'nowrap',
                      fontWeight: 400
                    }}
                  >
                    {availableAmenities[amenity].label}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Amenities;
